var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2419_3923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.40057 3.01375L14.8668 12.5056C15.2499 13.1744 14.7549 14 13.9662 14H3.03369C2.24494 14 1.74994 13.1744 2.13307 12.5056L7.59932 3.01375C7.99307 2.32875 9.00682 2.32875 9.40057 3.01375Z",
    stroke: "#CD3F00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.5V7",
    stroke: "#CD3F00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.375C8.84518 12.375 9.125 12.0952 9.125 11.75C9.125 11.4048 8.84518 11.125 8.5 11.125C8.15482 11.125 7.875 11.4048 7.875 11.75C7.875 12.0952 8.15482 12.375 8.5 12.375Z",
    fill: "#CD3F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2419_3923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.2dd45e7851871c3f109502bf74b1378b.svg";
export { ForwardRef as ReactComponent };